var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"app-main"},[_c('keep-alive',[(!_vm.$route.meta.noCache)?_c('router-view',{key:_vm.key}):_vm._e()],1),(_vm.$route.meta.noCache)?_c('router-view',{key:_vm.key}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }